import API from "../Endpoint/serviceConstrants";

const protectedEndpoints = [
  API.member,
  API.memberById,
  API.addToCart,
  API.userCartByMemberId,
  API.order,
  API.memberOrder,
  API.customerProductBudgetSummary,
  API.switch_AccountApi,
].map((endpoint) => endpoint.toLowerCase());

let unauthorized = false;
const listeners = new Set();

export const getUnauthorizedAccess = () => unauthorized;

export const subscribeUnauthorizedAccess = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const attachUnauthorizedAccessInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const config = error.config || error.response?.config;
      const pathname = new URL(
        config?.url || "",
        window.location.origin
      ).pathname.replace(/\/+$/, "").toLowerCase();
      const matchesEndpoint = protectedEndpoints.some(
        (endpoint) => pathname.endsWith(endpoint)
      );

      if ((status === 401 || status === 403) && matchesEndpoint && !unauthorized) {
        unauthorized = true;
        listeners.forEach((listener) => listener());
      }

      return Promise.reject(error);
    }
  );
};